/*
  Einstiegspunkt für die eigene Verfügbarkeit der Mitarbeitenden (/availability für User).
*/

import "../../../design-system/styles/tokens.css";
import "../../../design-system/styles/components.css";
import "../../availability/availability.css";
import "./employeeAvailability.css";
import EmployeeAvailabilityPage from "./EmployeeAvailabilityPage";

export default EmployeeAvailabilityPage;
